module.exports = __webpack_public_path__ + "img/home_sync.ff10be22.png";